/* Knowledge categories */
export const GET_KNOWLEDGE_CATEGORIES = "GET_KNOWLEDGE_CATEGORIES"
export const GET_KNOWLEDGE_CATEGORIES_SUCCESS =
  "GET_KNOWLEDGE_CATEGORIES_SUCCESS"
export const API_ERROR = "API_ERROR"
